/* (ignored) */


//////////////////
// WEBPACK FOOTER
// vertx (ignored)
// module id = 490
// module chunks = 0